import { useState } from "react";
import WpkGminyTab from "components/Settings/DictionariesTab/WpkGminyTab";
import MppTab from "components/Settings/DictionariesTab/MppTab";
import MigrationTab from "./MigrationTab";
import styles from "components/Settings/DictionariesTab/styles.module.scss";

type BudzetFkView = "migration" | "chart_of_accounts" | "mpk";

const BudzetFkTab = () => {
  const [view, setView] = useState<BudzetFkView>("migration");

  return (
    <div className={styles.wrapper}>
      <div className={styles.menu}>
        <div
          onClick={() => setView("migration")}
          className={`${styles.tab} ${view === "migration" ? styles.tabActive : ""}`}
        >
          Migracja danych
        </div>
        <div
          onClick={() => setView("chart_of_accounts")}
          className={`${styles.tab} ${view === "chart_of_accounts" ? styles.tabActive : ""}`}
        >
          Plan kont
        </div>
        <div
          onClick={() => setView("mpk")}
          className={`${styles.tab} ${view === "mpk" ? styles.tabActive : ""}`}
        >
          Miejsca powstawania kosztów
        </div>
      </div>

      <div className={styles.content}>
        {view === "migration" && <MigrationTab />}
        {view === "chart_of_accounts" && <WpkGminyTab />}
        {view === "mpk" && <MppTab />}
      </div>
    </div>
  );
};

export default BudzetFkTab;
